import { render, staticRenderFns } from "./Numeric.vue?vue&type=template&id=6206763e&"
import script from "./Numeric.vue?vue&type=script&lang=js&"
export * from "./Numeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports